module.exports = __webpack_public_path__ + "img/colored-square.94f40017.svg";